<template>
    <div>
        <section
            ref="section"
            role="dialog"
            tabindex="-1"
            class="slds-modal"
            :class="modalClass()"
        >
            <div class="slds-modal__container">
                <header
                    :class="{ 'slds-theme_alert-texture slds-theme_error': isPrompt }"
                    class="slds-modal__header"
                >
                    <button
                        v-if="!hideCloseButton"
                        class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
                        :title="closeLabel"
                        @click="$emit('close')"
                    >
                        <MAIconInline
                            :svg="require('!html-loader!@salesforce-ux/design-system/assets/icons/utility/close.svg')"
                            :iconClass="['slds-button__icon', 'slds-button__icon--large']"
                        />
                        <span class="slds-assistive-text">{{ closeLabel }}</span>
                    </button>

                    <h2
                        id="modal-heading-01"
                        class="slds-text-heading_medium slds-hyphenate"
                    >
                        {{ title }}
                    </h2>
                    <slot name="tagline"></slot>
                </header>

                <div
                    v-if="!isBodyless"
                    ref="content"
                    class="slds-modal__content slds-p-around_medium slds-is-relative"
                >
                    <MASpinner v-if="isLoading" />
                    <slot name="content">default content</slot>
                </div>

                <footer
                    v-if="!isLoading"
                    class="slds-modal__footer"
                    :class="{ 'ma-footer-bodyless': isBodyless }"
                >
                    <slot name="footer">default footer</slot>
                </footer>
            </div>
        </section>

        <div
            ref="backdrop"
            class="slds-backdrop"
        ></div>
    </div>
</template>

<script>
    import MASpinner from './MASpinner.vue';
    import MAIconInline from './ma-icon-inline';

    export default {
        name: 'MAModal',
        components: {
            MASpinner,
            MAIconInline
        },
        props: {
            title: {
                type: String,
                required: true
            },
            doDetach: {
                type: Boolean,
                default: false
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            isLarge: {
                type: Boolean,
                default: false
            },
            closeLabel: {
                type: String,
                default: 'Close'
            },
            isSmall: {
                type: Boolean,
                default: false
            },
            hideCloseButton: {
                type: Boolean,
                default: false
            },
            isBodyless: {
                type: Boolean,
                default: false
            },
            isPrompt: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                supressScrollEmitter: false,
                container: null
            };
        },
        mounted() {
            if (this.doDetach) {
                this.detach();
            }

            this.$emit('mounted');

            // TODO
            // Replace with CSS transitions
            setTimeout(() => {
                this.$refs.backdrop.classList.add('slds-backdrop_open');
            }, 1);

            setTimeout(() => {
                this.$refs.section.classList.add('slds-fade-in-open');
            }, 250);
        },
        beforeDestroy() {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
        },
        methods: {
            detach() {
                this.container = document.createElement('div');
                this.container.className = `slds-scope ${this.$el.className}`;
                this.container.appendChild(this.$el);
                document.body.appendChild(this.container);
            },
            modalClass() {
                return {
                    'slds-modal_small': this.isSmall,
                    'slds-modal_large': this.isLarge,
                    'slds-modal_prompt': this.isPrompt
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
    .slds-modal__content {
        min-height: 0px;
    }

    .slds-modal__content:last-child {
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    }

    ::v-deep .slds-notify {
        min-width: auto;
        width: 100%;
    }

    .slds-modal_small .slds-modal__container {
        width: 20rem;
    }

    .ma-footer-bodyless {
        border-top: none;
    }
</style>
